import React, { CSSProperties, ReactElement } from 'react'
import styled, { keyframes } from 'styled-components'

const Animation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
const SpinnerContainer = styled.div`
  .spinner {
    display: inline-block;
    animation-name: ${Animation};
    animation-timing-function: linear;
    animation-duration: 1s;
    animation-iteration-count: infinite;
  }
  .spinner:after {
    height: 10px;
    width: 10px;
    content: ' ';
    display: flex;
    border-radius: 50%;
    border: 3px solid;
    border-color: ${(props): string => props.color || 'inherit'};
    border-left-color: transparent;
    border-right-color: transparent;
  }
  &.loading-page {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
  }
`

export type ILoadingProps = {
  spinnerColor?: string
  className?: string
  fullPage?: boolean
  style?: CSSProperties
}

function Loading(props: ILoadingProps): ReactElement {
  const {
    spinnerColor, className, fullPage, style,
  } = props

  return (
    <SpinnerContainer
      color={spinnerColor}
      className={`${className} ${fullPage ? 'loading-page' : ''}`}
      style={style}
    >
      <div className="spinner" />
    </SpinnerContainer>
  )
}

export default Loading
